<template>
  <div class="insured" :style="{ backgroundImage: `url(${orgBackground})`}">
    <div class="insuredMain">
      <div>
        <div class="top">
          <img :src="zsb_H5MotorInsure" alt="">
          <div style="margin-top: 0.1rem; font-size: 0.16rem; color:#592581;font-weight: 600;">
            提交成功
          </div>
          <div class="topRadiu">
            <span>保单号：{{ policyNo }}</span>
          </div>
          <div style="line-height:160%;color:#333333;text-align:justify;font-family: 'PingFangSC-Regular';">
            尊敬的客户，摩托车{{ licenseNo }}已成功投保机动车交通事故责任强制保险，您可以通过"紫金保险"官方微信公众号、紫金财产保险股份有限公司客服电话(<span><a style="color: rgba(242, 150, 0, 1)" href="tel:95312">95312</a></span>)、公司柜面或登录公司网站"客户服务"板块(<a style="color: #592581" href="https://www.zking.com/">www.zking.com</a>)查询您的保单信息、状态及理赔情况。如您对查询结果有异议，请及时致电本公司。
          </div>
        </div>
        <div class="toubao" @click="toubao">
          还有其他摩托车？继续投保
        </div>
      </div>
      <div class="main">
        <div class="title">
          查看订单详情
        </div>
        <div v-for="(item,index) in content" :key="index" class="mainContain" @click="goNext(item)">
          <div style="margin-bottom:.12rem">
            订单号：<span style="color:#592581">{{ item.orderNo }}</span>
          </div>
          <img :src="zsb_H5MotorIcon">
        </div>
      </div>
      <div class="main " @click="goOrder">
        <div class="mainBox">
          <div>
            更多订单详情，请前往<span class="boldTitle">"我的订单"</span>
          </div>
          <div class="boldTitle" style="margin-left:.1rem">
            立即前往
            <img :src="insuredSuccess" alt="">
          </div>
        </div>
      </div>
      <div class="insuredBottom">
        <img :src="zsb_H5MotorLogo" alt="">
        <div>
          长按识别，关注"紫金保险"官方微信公众号登录"个人中心"，查看"我的保单"
        </div>
      </div>
      <Loading :switchs="switchs" />
    </div>
  </div>
</template>
<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading.vue'
import checkFormat from '@/utils/checkFormat.js'
import { removeWatermark, setWaterMark } from '../../watermark'
export default {
  components: {
    Loading: Loading
  },
  data() {
    return {
      orgBackground: '',
      licenseNo: '', // 车牌号
      policyNo: '', // 保单号
      switchs: false,
      content: [],
      zsb_H5MotorIcon: api.imgAllUrlZSB + '/zsb_H5MotorIcon.png',
      zsb_H5MotorLogo: api.imgAllUrlZSB + '/zsb_H5MotorLogo.jpg',
      zsb_H5MotorInsure: api.imgAllUrlZSB + '/zsb_H5MotorInsure.png',
      insuredSuccess: api.imgAllUrlZSB + '/insuredSuccess-iocn.png',
      comName: '', // 机构名
      comNameQuery: '',
      orderNo: '', // 订单号
      cInfo: ''
    }
  },
  created() {
    if (localStorage.getItem('setMotorCode')) {
      const motorCode = localStorage.getItem('setMotorCode')
      const areaName = motorCode.slice(0, -4)
      localStorage.setItem('setMotorAreaName', areaName)
      const comName = localStorage.getItem('setMotorAreaName')
      console.log(comName, 'comName=====>')
      this.comName = comName
      const orderNo = checkFormat.getUrlKey('orderNo')
      if (!checkFormat.isEmpty(orderNo)) {
        this.orderNo = orderNo
        this.comNameQuery = 'ALL'
      } else {
        this.orderNo = ''
        this.comNameQuery = comName
      }
    }
  },
  mounted() {
    this.getQueryLastEff()
    this.getList()
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
      if (this.comName === 'SHAAN_XI') {
        this.$http.get(`${api.buryPoint}?locationPointId=${api.pointOBj.successPoint}&userId=${this.cInfo.phoneNumber}`).then(res => {
          if (res.data.code === 200) {
            console.log('投保成功埋点成功')
          }
        })
      }
      
    }
  },
  destroyed() {
    removeWatermark()
  },
  methods: {
    goOrder() {
      this.$router.push('/motor/orderList')
    },
    toubao() {
      this.$router.push({ name: 'BaseInfo' })
    },
    goNext(orderConfig) {
      this.$router.push({
        name: 'motorConfirm',
        query: {
          orderId: this.$store.state.motorOrderId,
          orderNo: orderConfig.orderNo,
          encryptKey: orderConfig.encryptKey,
          terminalId: 'H5',
          channelCode: 'DP_OWXPA',
          isH5: '1'
        }
      })
    },
    getQueryLastEff() { // 车牌保单号
      // this.switchs = true
      // console.log(this.orderNo, 'orderNo')
      // console.log(this.comNameQuery, 'comNameQuery')
      const page = this.orderNo ? (`/${this.comNameQuery}` + `/${this.orderNo}`) : `/${this.comNameQuery}`
      this.$http.get(api.motorPolicy + page)
        .then(res => {
          if (res.data.rtnCode === '0000') {
            if (res.data.data && Object.keys(res.data.data).length > 0 && res.data.data.comName !== null) {
              localStorage.setItem('setMotorAreaName', res.data.data.comName)
              localStorage.setItem('setMotorCode', `${res.data.data.comName}Code`)
              this.licenseNo = res.data.data.licenseNo
              this.policyNo = res.data.data.policyNo
            }
          } else {
            this.$toast(res.data.rtnMsg)
          }
        // this.switchs = false
        }).catch(error => {
          this.switchs = false
          console.log(error)
          this.$toast('保单号获取失败,请稍后重试')
        })
    },
    getList() {
      // console.log(this.comName, 'this.comName')
      this.switchs = true
      this.$http.get(api.motorOrder + `/${this.comName}`).then(resTwo => {
        // console.log(resTwo.data, '-------')
        if (resTwo.data.rtnCode === '0000') {
          if (resTwo.data.data.length > 0) {
            this.content = resTwo.data.data.slice(0, 2)
          }
          // console.log(this.content, 'this.content')
        } else {
          this.$toast(resTwo.data.rtnMsg)
        }
        this.switchs = false
      }).catch(error => {
        this.switchs = false
        console.log(error)
        this.$toast('订单获取失败,请稍后重试')
      })
    }

  }

}
</script>
<style scoped lang="scss">
@import "/insuredSuccess";
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/insuredSuccess/index.vue